import IntranetLayout from "@/components/IntranetLayout";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { FileText, ClipboardList, Sparkles } from "lucide-react";
import { EmployeeDocumentsContent } from "./EmployeeDocuments";
import { DocumentControllerContent } from "./DocumentController";
import AIManagerPanel from "@/components/ai/AIManagerPanel";

const DocumentsSOPsHub = () => {
  return (
    <IntranetLayout>
      <div className="mb-4">
        <h1 className="text-2xl font-bold text-[#00283C] font-display">Documents & SOPs</h1>
        <p className="text-sm text-muted-foreground">
          Library, Vel-iO Document Controller and the Document Controller workspace — all in one place.
        </p>
      </div>

      <Tabs defaultValue="library" className="w-full">
        <TabsList className="bg-[#F4F7FA] mb-4 flex-wrap h-auto">
          <TabsTrigger value="library"><FileText className="w-4 h-4 mr-1" /> Document Library</TabsTrigger>
          <TabsTrigger value="ai"><Sparkles className="w-4 h-4 mr-1" /> Vel-iO Document Controller</TabsTrigger>
          <TabsTrigger value="controller"><ClipboardList className="w-4 h-4 mr-1" /> Document Controller</TabsTrigger>
        </TabsList>

        <TabsContent value="library" className="mt-0">
          <EmployeeDocumentsContent />
        </TabsContent>

        <TabsContent value="ai" className="mt-0">
          <AIManagerPanel
            hub="documents"
            title="Vel-iO Document Controller"
            subtitle="I track acknowledgement rates, flag overdue revisions, draft change summaries and reminders — pending your sign-off."
            accent="text-[#288CC8]"
            context="Hub: Document Controller. Focus on SMS, OPS, MNT, CRW, COMP and Corp documents. Track acknowledgement rates, review-due dates, OVMSA2/ISM compliance gaps, draft revisions for overdue documents."
          />
        </TabsContent>

        <TabsContent value="controller" className="mt-0">
          <DocumentControllerContent />
        </TabsContent>
      </Tabs>
    </IntranetLayout>
  );
};

export default DocumentsSOPsHub;
